import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FormPage.css"; // Make sure to create this CSS file for styling
import content from "../static/content.json";

function End() {
  const staticText = content.EndPage;
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate("/login");
    }, 5000); // 5-second delay

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  return (
    <div className="End">
      <div className="end-message-container">
        <h1>{staticText.FirstSentence}</h1>
        <p>{staticText.SecondSentence}</p>
        <p>{`Sie werden in ${countdown} Sekunden weitergeleitet...`}</p>
      </div>
    </div>
  );
}

export default End;
